'use client'

import { Dialog, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { WalletConversionErrorModel } from '@marketplace-web/business-accounts/business-accounts-data'

type Props = {
  error?: WalletConversionErrorModel
  onClose: () => void
}

const ErrorModal = ({ error, onClose }: Props) => {
  const translate = useTranslate('business.wallet.modal')

  if (!error) return null

  function getActions() {
    if (!error) return []

    const actions: React.ComponentProps<typeof Dialog>['actions'] = []

    if (error.buttonUrl && error.buttonTitle) {
      actions.push({
        text: error.buttonTitle,
        url: error.buttonUrl,
        style: 'filled',
      })
    }

    actions.push({
      text: translate('action.close'),
      callback: onClose,
      style: 'flat',
    })

    return actions
  }

  function renderBody() {
    return <Text as="span" html text={error?.body} />
  }

  return <Dialog show title={error.title} body={renderBody()} actions={getActions()} />
}

export default ErrorModal
